import React, { useState } from "react";
import styles from "./index.module.css";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Loading from "../../../../../common/components/Loading";
import moment from "moment";

// redux  
import { connect } from "react-redux";
import PropTypes from "prop-types";

const TableComp = ({ payment:{
  isGetAllPaymentHistoryOfCompanyLoading,
  paymentHistory, 
} }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Define the table columns
  const columns = [
    { id: "invoice", label: "Payment Invoice", minWidth: 170, align: "left" },
    { id: "amount", label: "Amount", minWidth: 100, align: "left" },
    { id: "date", label: "Date", minWidth: 170, align: "left" },
    { id: "status", label: "Status", minWidth: 170, align: "left" },
    // { id: "download", label: "Download", minWidth: 170, align: "center" },
  ];

  // Map real data to the table rows
  const rows = (paymentHistory || []).map((item) => ({
    invoice: item.paymentId, // Payment Invoice
    amount: item.amount, // Amount
    date: moment(item.createdAt).format("YYYY/MM/DD"), // Date
    status: item.status, // Status
  }));

  // Handle no data case
  const noData = !paymentHistory || paymentHistory === 0;

  return (
    <div className={styles.mainDiv}>
      {isGetAllPaymentHistoryOfCompanyLoading ? (
        <div className={styles.loadingContainer}>
          <Loading />
        </div>
      ) : (
        <Paper
        sx={{
          width: "100%",
          overflow: "auto",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "0.4em",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        <TableContainer sx={{ maxHeight: 540 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead
              sx={{
                "& th": {
                  backgroundColor: "#F7F7F7",
                  fontWeight: "bold",
                },
              }}
            >
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {noData ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.invoice}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "string"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {!noData && (
          <TablePagination
            rowsPerPageOptions={[5, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          )}
        </Paper>
      )}
    </div>
  );
};

TableComp.propTypes = {};

const mapStateToProps = (state) => ({ payment: state.paymentState });

export default connect(mapStateToProps, {})(TableComp);
